import { useLocation } from "react-router-dom";
import DeccanLoginPage from "./DeccanPages/DeccanLoginPage";
import PrajavaniLoginPage from "./PrajavaniPages/PrajavaniLoginPage";
import {
  DECCAN_URL,
  PRAJAVANI_URL,
  REDIRECT_URL,
} from "../contant";
import { doesSessionExist } from "supertokens-web-js/recipe/session";
import Cookies from "js-cookie";
import NotFoundPage from "../component/NotFoundPage";
import React, { useContext, useEffect, useMemo } from "react";
import LoaderComponent from "../component/LoaderComponent";
import { AppContext } from "..";
import {
  mapperRedirectUrlToRedirectAppInternalName,
  normalizeUrl,
  redirectWithFreshSession,
} from "../utiles";

export default function LoginPage() {
  const location = useLocation();
  const [isLoadingState, setIsLoadingState] = React.useState(true);
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get(REDIRECT_URL);
  const emailRequired = queryParams.get("emailRequired");
  const phoneNumberRequired = queryParams.get("phoneNumberRequired");
  const signupMessage = queryParams.get("signupMessage");

  const { setAppData } = useContext(AppContext);

  const normalizedCallbackUrl = useMemo(
    () => normalizeUrl(callbackUrl),
    [callbackUrl]
  );

  useEffect(() => {
    const redirectToAppName = mapperRedirectUrlToRedirectAppInternalName?.get(
      normalizedCallbackUrl
    );
    setAppData((prevAppData) => ({
      ...prevAppData,
      __internal_app_name: redirectToAppName,
    }));
  }, [normalizedCallbackUrl, setAppData]);

  localStorage.setItem("callbackUrl", callbackUrl);
  localStorage.setItem("emailRequired", emailRequired);
  localStorage.setItem("signupMessage", signupMessage);

  React.useEffect(() => {
    const checkSession = async () => {
      try {
        if (await doesSessionExist()) {
          // Option B: fresh session per handoff (see redirectWithFreshSession).
          await redirectWithFreshSession(callbackUrl, Cookies.get("st-access-token"));
          return;
        }
        setIsLoadingState(false);
        console.log("User has not logged in yet");
      } catch (error) {
        setIsLoadingState(false);
        console.error("Error checking session:", error);
      }
    };
    checkSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingState]);


  return (
    <>
      {isLoadingState ? (
        <LoaderComponent label={"Loading..."} />
      ) : callbackUrl?.toLowerCase()?.includes(PRAJAVANI_URL) ? (
        <PrajavaniLoginPage
          callbackUrl={callbackUrl}
          emailRequired={emailRequired}
          phoneNumberRequired={phoneNumberRequired}
          signupMessage={signupMessage}
        />
      ) : callbackUrl?.toLowerCase()?.includes(DECCAN_URL) ? (
        <DeccanLoginPage
          callbackUrl={callbackUrl}
          emailRequired={emailRequired}
          phoneNumberRequired={phoneNumberRequired}
          signupMessage={signupMessage}
        />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
}
